module.exports = __webpack_public_path__ + "static/media/video2.419c6843.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/images/video2.png
// module id = 972
// module chunks = 0